/**
 * herd
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: 0.220.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { NamespaceAuthorization } from './namespaceAuthorization';


export interface UserAuthorizations { 
    /**
     * The user id
     */
    userId: string;
    /**
     * The list of namespace authorizations
     */
    namespaceAuthorizations?: Array<NamespaceAuthorization>;
    /**
     * The list of security roles
     */
    securityRoles?: Array<string>;
    /**
     * The list of security functions
     */
    securityFunctions?: Array<string>;
}
